import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import FormRequest from '../common/formRequest';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { dtiFormEnum, itbiFormEnum } from 'src/app/Enums/SpecificFormInputEnum';
import { ApplicationItbiComponent } from './application-itbi/application-itbi.component';
import { CepService } from 'src/app/app-core/lib/cep.service';
import { EnderecoFormComponent } from 'src/app/components/endereco-form/endereco-form.component';
import { GenericValidator } from '../utilities/genericValidator';
import { FiscoService } from 'src/app/app-core/services/fisco.service';
import { RequestItbiComponent } from './request-itbi/request-itbi.component';
import { Subject, Subscription } from 'rxjs';
import { UserDataRequestService } from 'src/app/app-core/services/user-data-request.service';
import { takeUntil } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/app-core/services/local-storage.service';

@Component({
	selector: 'app-form-request-itbi',
	templateUrl: './form-request-itbi.component.html',
	styleUrls: ['./form-request-itbi.component.scss'],
	providers: [CepService, LocalStorageService]
})
export class FormRequestItbiComponent extends FormRequest implements OnInit, AfterViewInit, OnChanges, AfterViewChecked, OnDestroy {

	@ViewChild(ApplicationItbiComponent) applicationItbiComponent: ApplicationItbiComponent;
	@ViewChild('requestItbi') requestItbiComponent: RequestItbiComponent;
	@ViewChild(EnderecoFormComponent) enderecoFormComponent: EnderecoFormComponent;
	@Output() formDTIChange = new EventEmitter<{ form: any; validators: boolean }>();

	@Input() applicantDetails;

	public applicationComponentExist = false;
	public checkApplicantData = false;
	public subjectChangedOnce = false;
	public listRequest = [
		itbiFormEnum.ITBI_SOLICITACAO_NÃO_INCIDENCIA,
		itbiFormEnum.ITBI_SOLICITAÇÃO_DE_ISENÇÃO_DE_ITBI
	]
	public isRepresentingAnotherPerson: boolean = false;
	public subscription: Subscription;
	private hasFilledUserData = false;
	private formChangesSubscription: Subscription;
	public representativeData: any;
	private destroy$ = new Subject<void>();

	private localStorageKey = 'form-request-itbi';
	/** Lido no ngOnInit, antes de os subformulários gravarem por cima; aplicado no ngAfterViewInit. */
	private pendingDraft: any = null;

	public requiredFieldsApplication = [
		'tipoFormulario',
		'SOLIT_AdquirenteNome',
		'SOLIT_AdquirenteCPF',
		'SOLIT_AdquirenteEmail',
		'SOLIT_AdquirenteTelefone',
		'SOLIT_AdquirenteUF',
		'SOLIT_AdquirenteMunicipio',
		'SOLIT_AdquirenteLogradouro',
		'SOLIT_AdquirenteNumero',
		'SOLIT_AdquirenteBairro',
		'SOLIT_AdquirenteCEP',
		'SOLIT_AdquirenteEmail',
		'SOLIT_TransmitenteNome',
		'SOLIT_TransmitenteEmail',
		'SOLIT_TransmitenteTelefone',
		'SOLIT_TransmitenteUF',
		'SOLIT_TransmitenteMunicipio',
		'SOLIT_TransmitenteLogradouro',
		'SOLIT_TransmitenteNumero',
		'SOLIT_TransmitenteBairro',
		'SOLIT_TransmitenteCEP',
		'SOLIT_PercentualTransmitido',
		'SOLIT_NaturezaTransacao',
		'SOLIT_DataInstrumento',
		'SOLIT_ValorTransacao',
		'SOLIT_TransacaoValorFinanciado',
		'SOLIT_TransacaoValorNaoFinanciado',
		'SOLIT_TransacaoTotalDeclarado',
		'SOLIT_TransacaoTipoImovel',
		'SOLIT_TransacaoNaturezaImovel',
		'SOLIT_TransacaoEndereco',
		'SOLIT_TransacaoAreaTerreno',
		'SOLIT_TransacaoLote',
		'SOLIT_TransacaoQuadra',
		'SOLIT_TransacaoNumero',
		'SOLIT_TransacaoAreaTotal'
	];

	public camposAdicionais = [
		'transmitenteAdicional.nomeAdicional',
		'transmitenteAdicional.cpfCnpjAdicional',
		'transmitenteAdicional.cepAdicional',
		'transmitenteAdicional.ufAdicional',
		'transmitenteAdicional.municipioAdicional',
		'transmitenteAdicional.logradouroAdicional',
		'transmitenteAdicional.numeroAdicional',
		'transmitenteAdicional.bairroAdicional',
	];

	public requiredFieldsRequests = [
		'SOLIT_SolicitanteNomeRazaoSocial',
		'SOLIT_SolicitanteCpfCnpj',
		'SOLIT_SolicitanteTelefone',
		'SOLIT_SolicitanteUF',
		'SOLIT_SolicitanteMunicipio',
		'SOLIT_SolicitanteLogradouro',
		'SOLIT_SolicitanteNumero',
		'SOLIT_SolicitanteBairro',
		'SOLIT_SolicitanteCEP',
		'SOLIT_Logradouro',
		'SOLIT_Numero',
		'SOLIT_Bairro',
		'SOLIT_CEP',
		'SOLIT_Inscricao',
		'SOLIT_NaturezaTransacao'
	];

	constructor(
		public fb: FormBuilder,
		public fiscoService: FiscoService,
		private userDataRequestService: UserDataRequestService,
		private cd: ChangeDetectorRef,
		private localStorageService: LocalStorageService,
	) {
		super(fb, fiscoService);
	}

	ngOnInit(): void {
		this.pendingDraft = this.getFromLocalStorage();

		this.initForm();
		this.formChanges();
		this.bindFormChanges();
		this.watchFormChanges();

		this.form.valueChanges
			.pipe(takeUntil(this.destroy$))
			.subscribe(() => {
				this.formDTIChange.emit({ form: this.form.value, validators: this.form.valid });
			});

		this.userDataRequestService.getRepresentingAnotherPerson()
			.pipe(takeUntil(this.destroy$))
			.subscribe(value => {
				this.isRepresentingAnotherPerson = value;
				this.cd.detectChanges();
				this.handleRepresentationChange();
			});

		this.userDataRequestService.getRepresentativeData()
			.pipe(takeUntil(this.destroy$))
			.subscribe(data => {
				this.representativeData = data;
				if (this.isRepresentingAnotherPerson && this.representativeData) {
					this.fillFieldsWithUserData();
				}
			});
	}

	ngOnChanges(changes: SimpleChanges): void {

		if (changes.subject && this.subjectChangedOnce) {
			this.resetFormGroupsBySubject();
		}
		else {
			this.subjectChangedOnce = true;
		}
	}

	ngAfterViewInit(): void {
		this.initApplicationItbi();
		this.initRequestItbi();

		this.form.get('tipoFormulario')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.hasFilledUserData = false;
		});

		if (this.applicationItbiComponent) {
			this.applicationItbiComponent.transmitenteAdicionalObrigatorioChange
				.pipe(takeUntil(this.destroy$))
				.subscribe((checked: boolean) => {
					this.onTransmitenteAdicionalObrigatorioChange(checked);
				});

			this.bindTransmitterChanges();
		}

		if (this.pendingDraft) {
			// Fora deste ciclo de detecção: a restauração mexe em campos já desenhados e pode
			// recriar adquirente e transmitente.
			setTimeout(() => this.restoreDraft());
		}
	}

	ngAfterViewChecked(): void {
		if (!this.hasFilledUserData && this.applicationItbiComponent?.acquirerItbiComponent && this.applicationItbiComponent?.transmitteritbicomponent) {
			this.fillFieldsWithUserData();
			this.hasFilledUserData = true;
		}
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	initForm() {
		this.renderForm();
		if (this.haveSubject(this.listRequest)) {
			this.setValidatorsForm(this.requiredFieldsRequests);
		}

		if (this.haveSubject([dtiFormEnum.DECLARACAO_DE_TRANSMISSAO_IMOBILIARIA])) {
			this.applicationComponentExist = true;

			const checkboxAtivo = this.form.get('duplicarFormulario').value;
			this.onTransmitenteAdicionalObrigatorioChange(checkboxAtivo);
		}
	}

	onTransmitenteAdicionalObrigatorioChange(checked: boolean) {
		this.prepareValidationApplication(checked);
	}

	renderForm() {
		this.form = this.fb.group({
			tipoFormulario: [''],
			SOLIT_SolicitanteNomeRazaoSocial: [''],
			SOLIT_SolicitanteCpfCnpj: [''],
			SOLIT_SolicitanteEstadoCivil: [''],
			SOLIT_SolicitanteRG: [''],
			SOLIT_SolicitanteTelefone: [''],
			SOLIT_SolicitanteEmail: [''],
			SOLIT_SolicitanteUF: [''],
			SOLIT_SolicitanteMunicipio: [''],
			SOLIT_SolicitanteLogradouro: [''],
			SOLIT_SolicitanteNumero: [''],
			SOLIT_SolicitanteBairro: [''],
			SOLIT_SolicitanteComplemento: [''],
			SOLIT_SolicitanteCEP: [''],
			SOLIT_Inscricao: [''],
			SOLIT_TipoImovel: ['Urbano'],
			SOLIT_ValorDeclarado: [null],
			SOLIT_AreaTerreno: [null],
			SOLIT_AreaEdificadaTotal: [null],
			SOLIT_UF: ['CE'],
			SOLIT_Municipio: ['São Gonçalo do Amarante'],
			SOLIT_Logradouro: [''],
			SOLIT_Numero: [''],
			SOLIT_Bairro: [''],
			SOLIT_Complemento: [''],
			SOLIT_CEP: [''],
			SOLIT_NaturezaOperacao: [''],
			SOLIT_SolicitanteConjugue: [''],
			SOLIT_AdquirenteNome: [''],
			SOLIT_AdquirenteCPF: [''],
			SOLIT_AdquirenteEmail: [''],
			SOLIT_AdquirenteTelefone: [''],
			SOLIT_AdquirenteUF: [''],
			SOLIT_AdquirenteMunicipio: [''],
			SOLIT_AdquirenteLogradouro: [''],
			SOLIT_AdquirenteNumero: [''],
			SOLIT_AdquirenteBairro: [''],
			SOLIT_AdquirenteComplemento: [''],
			SOLIT_AdquirenteCEP: [''],
			SOLIT_TransmitenteNome: [''],
			SOLIT_TransmitenteCPF: [''],
			SOLIT_TransmitenteEmail: [''],
			SOLIT_TransmitenteTelefone: [''],
			SOLIT_TransmitenteUF: [''],
			SOLIT_TransmitenteMunicipio: [''],
			SOLIT_TransmitenteLogradouro: [''],
			SOLIT_TransmitenteNumero: [''],
			SOLIT_TransmitenteBairro: [''],
			SOLIT_TransmitenteComplemento: [''],
			SOLIT_TransmitenteCEP: [''],
			SOLIT_NaturezaTransacao: [''],
			SOLIT_DataInstrumento: [''],
			SOLIT_ValorTransacao: [''],
			SOLIT_PercentualTransmitido: [''],
			SOLIT_TransacaoMatricula: [''],
			SOLIT_TransacaoInscricao: [''],
			SOLIT_TransacaoEndereco: [''],
			SOLIT_TransacaoNumero: [''],
			SOLIT_TransacaoComplemento: [''],
			SOLIT_TransacaoLote: [''],
			SOLIT_TransacaoQuadra: [''],
			SOLIT_TransacaoTipoImovel: [''],
			SOLIT_TransacaoNaturezaImovel: [''],
			SOLIT_TransacaoAreaTerreno: [null],
			SOLIT_TransacaoAreaTotal: [null],
			SOLIT_TransacaoValorFinanciado: [null],
			SOLIT_TransacaoValorNaoFinanciado: [null],
			SOLIT_TransacaoTotalDeclarado: [null],
			transmitenteAdicional: this.fb.array([
				this.fb.group({
					nomeAdicional: [''],
					cpfCnpjAdicional: [''],
					cepAdicional: [''],
					ufAdicional: [''],
					municipioAdicional: [''],
					logradouroAdicional: [''],
					numeroAdicional: [''],
					complementoAdicional: [''],
					bairroAdicional: [''],
				})
			]),
			duplicarFormulario: [false],
			SOLIT_Descricao: [''],
			formVariants: this.fb.group({
				SOL_Descricao: ['', Validators.required],
				termCheck: [false]
			})
		}, { validators: this.acquirerValidator });

	}

	private initApplicationItbi() {
		if (this.applicationComponentExist && this.applicationItbiComponent?.form?.pristine) {
			this.applicationItbiComponent.form.valueChanges
				.pipe(takeUntil(this.destroy$))
				.subscribe(() => {
					const rawValue = this.applicationItbiComponent.form.getRawValue();
					const transmitenteAdicionalArray = this.form.get('transmitenteAdicional') as FormArray;

					const duplicados = transmitenteAdicionalArray.value.length ? transmitenteAdicionalArray.value : rawValue.duplicados || [];

					this.form.patchValue({ ...rawValue, transmitenteAdicional: duplicados });
					this.form.updateValueAndValidity();
				});
		}
	}

	private initRequestItbi() {
		if (this.requestItbiComponent) {
			this.requestItbiComponent.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((response) => {
				this.form.patchValue(
					this.requestItbiComponent.form.getRawValue()
				);
				this.form.updateValueAndValidity();
			});
		}
	}

	getAddressImmobile(event) {
		this.form.get('SOLIT_Municipio').setValue(event.localidade);
		this.form.get('SOLIT_Bairro').setValue(event.bairro);
		this.form.get('SOLIT_Logradouro').setValue(event.logradouro);
		this.form.get('SOLIT_UF').setValue(event.uf);
		this.form.get('SOLIT_Numero').setValue(event.numero);
		this.form.get('SOLIT_Complemento').setValue(event.complemento);
		this.form.get('SOLIT_CEP').setValue(event.CEP);
	}

	getApplicationItbi() {
		this.form.setValue(this.applicationItbiComponent.form.getRawValue());
		this.form.updateValueAndValidity();
	}

	private prepareValidationApplication(duplicarAtivo: boolean) {
		this.form.get('formVariants.termCheck')?.setValidators(Validators.requiredTrue);

		this.form.get('SOLIT_TransmitenteCPF')?.setValidators([
			Validators.required,
			GenericValidator.isValidCpfOrCnpj()
		]);

		this.setValidatorsForm(this.requiredFieldsApplication);

		this.setDuplicadoValidators(duplicarAtivo);

		this.form.updateValueAndValidity();
	}

	private setDuplicadoValidators(apply: boolean) {

		const transmitenteAdicionalArray = this.form.get('transmitenteAdicional') as FormArray;

		transmitenteAdicionalArray.controls.forEach((group: FormGroup) => {
			Object.keys(group.controls).forEach(controlName => {
				const control = group.get(controlName);
				if (!control) return;

				if (controlName !== 'complementoAdicional') {
					if (apply) {
						control.setValidators([Validators.required]);
					} else {
						control.clearValidators();
					}
				}
				control.updateValueAndValidity();
			});
		});
	}


	private setValidatorsForm(list: string[]) {
		const allFields = Object.keys(this.form.controls);
		for (const field of allFields) {
			const control = this.form.get(field);

			if (list.includes(field)) {
				control.setValidators([Validators.required]);
			}
			control.updateValueAndValidity();
		}
	}


	private resetFormGroupsBySubject() {
		this.applicationComponentExist = false;
		if (this.enderecoFormComponent) {
			this.enderecoFormComponent.reset();
		}
		this.form.patchValue(this.fb.group({}));
		this.initForm();
		this.form.updateValueAndValidity();
		this.formChanges();
		// this.form é uma instância nova: a gravação do rascunho precisa seguir o form atual
		this.pendingDraft = null;
		this.watchFormChanges();
	}

	// ------------------------------------------------------------------
	// Rascunho
	// ------------------------------------------------------------------

	/**
	 * Os campos vivem nos subformulários (request-itbi no ITBI; adquirente e transmitente na
	 * DTI) e chegam aqui por cópia, então o rascunho guarda os subformulários. O termo fica de
	 * fora: é aceito no envio.
	 */
	private watchFormChanges(): void {
		this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.localStorageService.set(this.localStorageKey, {
				subject: this.subject,
				descricao: this.form.get('formVariants.SOL_Descricao')?.value,
				request: this.requestItbiComponent?.draftValue || null,
				application: this.applicationComponentExist ? this.applicationItbiComponent?.draftValue || null : null,
			});
		});
	}

	/** Os subformulários mudam com o assunto: só vale o rascunho do mesmo assunto. */
	private getFromLocalStorage(): any {
		const storageData = this.localStorageService.get<any>(this.localStorageKey);

		if (!storageData || typeof storageData !== 'object' || storageData.subject !== this.subject) return null;

		return storageData;
	}

	private restoreDraft(): void {
		const draft = this.pendingDraft;
		this.pendingDraft = null;

		if (!draft) return;

		this.form.get('formVariants.SOL_Descricao')?.setValue(draft.descricao ?? '');

		if (draft.request && this.requestItbiComponent) {
			this.requestItbiComponent.restoreDraft(draft.request);
		}

		if (draft.application && this.applicationItbiComponent) {
			const tipo = draft.application.tipoFormulario;
			const tipoControl = this.applicationItbiComponent.form.get('tipoFormulario');

			if (tipo && tipoControl.value !== tipo) {
				// Adquirente e transmitente trocam de ordem e são recriados: só então recebem os dados.
				tipoControl.setValue(tipo);
				this.cd.detectChanges();
				this.fillFieldsWithUserData();
				this.hasFilledUserData = true;
			}

			this.applicationItbiComponent.restoreDraft(draft.application);
		}
	}

	acquirerValidator(form: FormGroup) {
		const transmitenteCPF = form.get('SOLIT_TransmitenteCPF').value;
		const adquirenteCPF = form.get('SOLIT_AdquirenteCPF').value;
		if (transmitenteCPF && adquirenteCPF && transmitenteCPF === adquirenteCPF) {
			return { acquirerMismatch: true };
		}
		return null;
	}

	fillFieldsWithUserData() {
		let acquirerData, transmitterData;

		if (this.isRepresentingAnotherPerson && this.representativeData) {
			if (this.form.get('tipoFormulario')?.value === 'adquirente') {
				acquirerData = {
					SOLR_CpfCnpj: this.representativeData.SOLR_CpfCnpj,
					SOLR_NomeRazaoSocial: this.representativeData.SOLR_NomeRazaoSocial,
					SOLR_Email: this.representativeData.SOLR_Email,
					SOLR_Telefone: this.representativeData.SOLR_Telefone
				};
			} else if (this.form.get('tipoFormulario')?.value === 'transmitente') {
				transmitterData = {
					SOLR_CpfCnpj: this.representativeData.SOLR_CpfCnpj,
					SOLR_NomeRazaoSocial: this.representativeData.SOLR_NomeRazaoSocial,
					SOLR_Email: this.representativeData.SOLR_Email,
					SOLR_Telefone: this.representativeData.SOLR_Telefone
				};
			}
		} else {
			acquirerData = this.applicationItbiComponent.acquirerItbiComponent?.acquirerDetails;
			transmitterData = this.applicationItbiComponent.transmitteritbicomponent?.transmitterDetails;
		}

		if (acquirerData) {
			this.applicationItbiComponent.acquirerItbiComponent.form.patchValue({
				CPF: acquirerData.SOLR_CpfCnpj,
				nome: acquirerData.SOLR_NomeRazaoSocial,
				email: acquirerData.SOLR_Email,
				telefone: acquirerData.SOLR_Telefone
			});
			this.applicationItbiComponent.acquirerItbiComponent.form.get('CPF')?.disable();
			this.applicationItbiComponent.acquirerItbiComponent.form.get('nome')?.disable();
			this.applicationItbiComponent.acquirerItbiComponent.form.get('email')?.disable();
			this.applicationItbiComponent.acquirerItbiComponent.form.get('telefone')?.disable();
		}

		if (transmitterData) {
			this.applicationItbiComponent.transmitteritbicomponent.form.patchValue({
				CPF: transmitterData.SOLR_CpfCnpj,
				nome: transmitterData.SOLR_NomeRazaoSocial,
				email: transmitterData.SOLR_Email,
				telefone: transmitterData.SOLR_Telefone
			});
			this.applicationItbiComponent.transmitteritbicomponent.form.get('CPF')?.disable();
			this.applicationItbiComponent.transmitteritbicomponent.form.get('nome')?.disable();
			this.applicationItbiComponent.transmitteritbicomponent.form.get('email')?.disable();
			this.applicationItbiComponent.transmitteritbicomponent.form.get('telefone')?.disable();
		}
	}


	handleRepresentationChange() {
		if (!this.applicationItbiComponent) return;

		if (this.formChangesSubscription) {
			this.formChangesSubscription.unsubscribe();
		}

		if (!this.isRepresentingAnotherPerson) {
			this.form.reset();
			this.bindFormChanges();

			this.applicationItbiComponent.acquirerItbiComponent.acquirerDisabled = false;
			this.applicationItbiComponent.transmitteritbicomponent.transmitterDisabled = false;

			this.fillFieldsWithUserData();

			this.applicationItbiComponent.clearAcquirerAndTransmitter();
			this.applicationItbiComponent.reset();

		} else {
			this.form.reset();
			this.bindFormChanges();

			this.applicationItbiComponent.acquirerItbiComponent.acquirerDisabled = true;
			this.applicationItbiComponent.transmitteritbicomponent.transmitterDisabled = true;

			this.applicationItbiComponent.clearAcquirerAndTransmitter();
			this.applicationItbiComponent.reset();
		}

		this.cd.detectChanges();
	}

	private bindFormChanges(): void {
		if (this.formChangesSubscription) {
			this.formChangesSubscription.unsubscribe();
		}

		this.formChangesSubscription = this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.formDTIChange.emit({ form: this.form.value, validators: this.form.valid });
		});

		this.formDTIChange.emit({ form: this.form.value, validators: this.form.valid });
	}

	private bindTransmitterChanges() {
		if (!this.applicationItbiComponent?.transmitteritbicomponent) return;

		const transmitter = this.applicationItbiComponent.transmitteritbicomponent;

		transmitter.onTransmitterChange
			.pipe(takeUntil(this.destroy$))
			.subscribe((transmitterData: any) => {
				this.updateTransmitenteAdicional(transmitterData);
			});
	}

	private updateTransmitenteAdicional(transmitterData: any) {
		const formArray = this.form.get('transmitenteAdicional') as FormArray;

		while (formArray.length) {
			formArray.removeAt(0);
		}

		if (transmitterData?.duplicados?.length) {
			transmitterData.duplicados.forEach(dup => {
				formArray.push(this.fb.group({
					nomeAdicional: dup.nomeAdicional || '',
					cpfCnpjAdicional: dup.cpfCnpjAdicional || '',
					cepAdicional: dup.cepAdicional || '',
					ufAdicional: dup.ufAdicional || '',
					municipioAdicional: dup.municipioAdicional || '',
					logradouroAdicional: dup.logradouroAdicional || '',
					numeroAdicional: dup.numeroAdicional || '',
					bairroAdicional: dup.bairroAdicional || '',
					complementoAdicional: dup.complementoAdicional || '',
				}));
			});
		}

		const duplicarAtivo = this.applicationItbiComponent.transmitteritbicomponent?.isDuplicarFormulario;
		this.setDuplicadoValidators(duplicarAtivo);
		this.form.updateValueAndValidity();
	}
}
